import axiosInstance from './axiosInstance';

const niveauService = {
    // Public endpoints
    getNiveaux: async () => {
        const response = await axiosInstance.get('/niveaux');
        return response.data;
    },

    // Admin endpoints
    getAllNiveaux: async () => {
        const response = await axiosInstance.get('/niveaux/all');
        return response.data;
    },

    createNiveau: async (niveauData) => {
        const response = await axiosInstance.post('/niveaux', niveauData);
        return response.data;
    },

    updateNiveau: async (id, niveauData) => {
        const response = await axiosInstance.put(`/niveaux/${id}`, niveauData);
        return response.data;
    },

    deleteNiveau: async (id) => {
        const response = await axiosInstance.delete(`/niveaux/${id}`);
        return response.data;
    }
};

export default niveauService;
